export default __webpack_public_path__ + "static/media/pasta-menu-selecionado.5596622b.svg";